import {
  Table,
  AddRowButton,
  RemoveRowButton,
  Form,
  Input,
  InputNumber,
  Radio,
  DatePickerProps,
  FormikDebug,
} from "formik-antd";
import _ from "lodash";
import { Formik } from "formik";
import { Button, Space, DatePicker, Row, Col, Alert, message } from "antd";
import React, { useContext, useEffect, useState } from "react";
import MultiStepFormContext from "./MultiStepFormContext";
import { DeleteOutlined } from "@ant-design/icons";
import moment from "moment";
import dayjs from "dayjs";
import axios from "axios";
import { Backdrop, CircularProgress } from "@mui/material";

export default function FamilyDetails() {
  const { familyDetails, setFamilyDetails, next, setStepIsValid, stepIsValid } =
    useContext(MultiStepFormContext);
  const [alertVisible, setAlertVisible] = useState(false);
  const [alertType, setAlertType] = useState("success");
  const [loading, setLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState("Data Saved Successfully!!");
  function onFinish(values) {
    next();
  }
  const handleClose = () => {
    setAlertVisible(false);
  };

  useEffect(() => {
    const applicationId = sessionStorage.getItem("applicationId");
    if (applicationId == "undefined") {
      const requestOptions = {
        data: sessionStorage.getItem("token"),
      };
      const getData = async () => {
        const url = window.API_PREFIX + "forms/api/get/all";
        return await axios.post(url, requestOptions);
      };
      getData()
        .then((res) => {
          const applicationId = res.data.application_data.id;
          sessionStorage.setItem("applicationId", applicationId);
        })
        .catch((err) => console.log(err));
    }
  }, []);

  const separateAndCapitalize = (string) => {
    const seperatedString = _.startCase(string);
    return _.capitalize(seperatedString);
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flex: 1,
        justifyContent: "center",
      }}
    >
      <Formik
        initialValues={familyDetails}
        onSubmit={(values) => {
          setLoading(true);
          setFamilyDetails(values);
          var url = window.API_PREFIX + "forms/api/post/family_members";
          const requestOptions = {
            data: values,
            applicationId: sessionStorage.getItem("applicationId"),
            user: sessionStorage.getItem("username"),
            token: sessionStorage.getItem("token"),
          };
          axios
            .post(url, requestOptions)
            .then((res) => {
              if (res.data.status == 200) {
                setAlertType("success");
                setAlertMessage(res.data.info);
                setAlertVisible(true);
              } else if (res.data.status == 409) {
                setAlertType("info");
                setAlertMessage(res.data.info);
                setAlertVisible(true);
              }
              setStepIsValid({
                ...stepIsValid,
                familyDetails: "finish",
              });
              onFinish();
            })
            .catch((err) => {
              message.error(
                "Please fill the correct information. Try again after refreshing the page",
                10
              );
              setStepIsValid({
                ...stepIsValid,
                familyDetails: "error",
              });
            })
            .finally(() => {
              setLoading(false);
            });
        }}
        validateOnChange={true}
        validateOnBlur={true}
        validate={(values) => {
          var errors = [];
          var family1 = [];
          var family = values["familyDetails"];
          for (var i = 0; i < family.length; i++) {
            let error = {};

            Object.keys(family[i]).map((key) => {
              if (
                family[i][key] === "" ||
                family[i][key] === null ||
                family[i][key] == dayjs()
              ) {
                error[key] = separateAndCapitalize(key) + " is required";
              }
            });

            // Check for annual income validation
            if (
              family[i]["annualIncome"] &&
              parseFloat(family[i]["annualIncome"]) > 500000
            ) {
              error["annualIncome"] =
                "Annual income cannot be greater than ₹5,00,000.";
            }

            if (Object.keys(error).length == 0) {
              family1.push(null);
            } else {
              family1.push(error);
            }
          }
          errors = family1;
          if (
            errors.every((item) => {
              return item == null;
            })
          ) {
            return [];
          }
          return errors;
        }}
      >
        {({ handleSubmit, values, setFieldValue, errors, touched }) => (
          <div>
            <Table
              name="familyDetails"
              rowKey={(row, index) => "" + index}
              size="small"
              pagination={false}
              style={{ width: "100%", margin: "2%" }}
              columns={[
                {
                  title: "Name",
                  key: "name",
                  render: (text, record, i) => (
                    <>
                      <Input
                        name={`familyDetails.${i}.name`}
                        placeholder="Enter name"
                      />
                      {errors[i] &&
                      "name" in errors[i] &&
                      touched &&
                      "familyDetails" in touched &&
                      touched["familyDetails"][i] &&
                      "name" in touched["familyDetails"][i] &&
                      touched["familyDetails"][i]["name"] ? (
                        <div style={{ color: "red" }}>{errors[i]["name"]}</div>
                      ) : null}
                    </>
                  ),
                },
                {
                  title: "Relationship",
                  key: "relationship",
                  render: (text, record, i) => (
                    <>
                      <Input
                        name={`familyDetails.${i}.relationship`}
                        placeholder="e.g. mother,father,brother"
                      />
                      {errors[i] &&
                      "relationship" in errors[i] &&
                      touched &&
                      "familyDetails" in touched &&
                      touched["familyDetails"][i] &&
                      "relationship" in touched["familyDetails"][i] &&
                      touched["familyDetails"][i]["relationship"] ? (
                        <div style={{ color: "red" }}>
                          {errors[i]["relationship"]}
                        </div>
                      ) : null}
                    </>
                  ),
                },
                {
                  title: "Date of Birth",
                  key: "dateOfBirth",
                  render: (text, record, i) => (
                    <>
                      <DatePicker
                        name={`familyDetails.${i}.dateOfBirth`}
                        // defaultValue={familyDetails["familyDetails"][i].dateOfBirth}
                        // showTime={true}
                        defaultValue={values["familyDetails"][i].dateOfBirth}
                        placeholder="DatePicker"
                        placement="bottomLeft"
                        onChange={(date, dateString) => {
                          if (dateString == "") {
                            setFieldValue(
                              `familyDetails.${i}.dateOfBirth`,
                              undefined
                            );
                          } else {
                            setFieldValue(
                              `familyDetails.${i}.dateOfBirth`,
                              dayjs(dateString)
                            );
                          }
                        }}
                      />
                      {errors[i] &&
                      "dateOfBirth" in errors[i] &&
                      touched &&
                      "familyDetails" in touched &&
                      touched["familyDetails"][i] &&
                      "dateOfBirth" in touched["familyDetails"][i] &&
                      touched["familyDetails"][i]["dateOfBirth"] ? (
                        <div style={{ color: "red" }}>
                          {errors[i]["dateOfBirth"]}
                        </div>
                      ) : null}
                    </>
                  ),
                },
                {
                  title: "Education",
                  key: "education",
                  render: (text, record, i) => (
                    <>
                      <Input
                        // style={{ border: "none" }}
                        name={`familyDetails.${i}.education`}
                        placeholder="e.g. BE, BCom, BCA"
                      />
                      {errors[i] &&
                      "education" in errors[i] &&
                      touched &&
                      "familyDetails" in touched &&
                      touched["familyDetails"][i] &&
                      "education" in touched["familyDetails"][i] &&
                      touched["familyDetails"][i]["education"] ? (
                        <div style={{ color: "red" }}>
                          {errors[i]["education"]}
                        </div>
                      ) : null}
                    </>
                  ),
                },
                {
                  title: "Occupation",
                  key: "occupation",
                  render: (text, record, i) => (
                    <>
                      <Input
                        // style={{ border: "none" }}
                        name={`familyDetails.${i}.occupation`}
                      />
                      {errors[i] &&
                      "occupation" in errors[i] &&
                      touched &&
                      "familyDetails" in touched &&
                      touched["familyDetails"][i] &&
                      "occupation" in touched["familyDetails"][i] &&
                      touched["familyDetails"][i]["occupation"] ? (
                        <div style={{ color: "red" }}>
                          {errors[i]["occupation"]}
                        </div>
                      ) : null}
                    </>
                  ),
                },
                {
                  title: "Annual Income",
                  key: "annualIncome",
                  render: (text, record, i) => (
                    <>
                      <Input
                        type="number"
                        name={`familyDetails.${i}.annualIncome`}
                        placeholder="in INR"
                        min={0}
                      />
                      {errors[i] &&
                      "annualIncome" in errors[i] &&
                      touched &&
                      "familyDetails" in touched &&
                      touched["familyDetails"][i] &&
                      "annualIncome" in touched["familyDetails"][i] &&
                      touched["familyDetails"][i]["annualIncome"] ? (
                        <div style={{ color: "red" }}>
                          {errors[i]["annualIncome"]}
                        </div>
                      ) : null}
                    </>
                  ),
                },
                {
                  title: "Dependent",
                  key: "dependent",
                  render: (text, record, i) => (
                    <>
                      <Radio.Group name={`familyDetails.${i}.dependent`}>
                        <Space direction="horizontal">
                          <Radio
                            name={`familyDetails.${i}.dependent`}
                            value={true}
                          >
                            Yes
                          </Radio>
                          <Radio
                            name={`familyDetails.${i}.dependent`}
                            value={false}
                          >
                            No
                          </Radio>
                        </Space>
                        {/* <Radio value={details[item].radio}>{details[item].radio[1]}</Radio> */}
                      </Radio.Group>
                      {errors[i] &&
                      "dependent" in errors[i] &&
                      touched &&
                      "familyDetails" in touched &&
                      touched["familyDetails"][i] &&
                      "dependent" in touched["familyDetails"][i] &&
                      touched["familyDetails"][i]["dateOfBirth"] ? (
                        <div style={{ color: "red" }}>
                          {errors[i]["dependent"]}
                        </div>
                      ) : null}
                    </>
                  ),
                },
                {
                  key: "actions",
                  render: (text, record, index) => (
                    <RemoveRowButton
                      style={{ border: "none" }}
                      icon={<DeleteOutlined />}
                      name="familyDetails"
                      index={index}
                    />
                  ),
                },
              ]}
            />
            <Row gutter={10} style={{ margin: "50px" }}>
              <AddRowButton
                name="familyDetails"
                style={{ marginBottom: 12 }}
                createNewRow={() => ({
                  name: "",
                  relationship: "",
                  dateOfBirth: "",
                  education: "",
                  occupation: "",
                  annualIncome: "",
                  dependent: "",
                })}
              >
                Add Family Member
              </AddRowButton>
            </Row>
            <Row gutter={10} style={{ margin: "50px" }}>
              <Space direction="vertical" style={{ width: "100%" }}>
                {alertVisible && (
                  <Alert
                    message={alertMessage}
                    type={alertType}
                    closable
                    afterClose={handleClose}
                  />
                )}
                {alertVisible}
              </Space>
            </Row>
            <Row gutter={10} style={{ margin: "50px" }}>
              <Col>
                <Button type={"primary"} onClick={handleSubmit}>
                  Save
                </Button>
              </Col>
              {/* <Col>
                                <Button type={"success"} onClick={onFinish}>
                                    Next
                                </Button>
                            </Col> */}
            </Row>
          </div>
        )}
      </Formik>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
